import {Tag} from 'antd';

import {Locale} from '../../../../../../provider/locale/locale';
import {AiMonitoringSentimentEnum} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

import {SENTIMENT_LANG_KEY_MAP, SENTIMENT_TAG_COLOR_MAP} from './answers-feed-const';

type PropsType = {
    sentiment: AiMonitoringSentimentEnum;
};

// Tone of the brand's mention inside the answer.
export function AnswerSentimentTag(props: PropsType): JSX.Element {
    const {sentiment} = props;

    return (
        <Tag color={SENTIMENT_TAG_COLOR_MAP[sentiment]}>
            <Locale stringKey={SENTIMENT_LANG_KEY_MAP[sentiment]} />
        </Tag>
    );
}
